import React from 'react';
import HeaderSeven from '../../components/Header/HeaderFive';
import Footer from '../../components/Footer/FooterThree';
import InfectionMain from './InfectionMain';

const InfectionPrevention = () => {
  return (
    <>
      <HeaderSeven />
      <InfectionMain/>
      <Footer />
    </>
  );
};

export default InfectionPrevention;
